import { memo } from "react"
import { useTranslation } from "react-i18next"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@f2e/ui/components/base"

export type ThreadStatusFilterValue = "all" | "pending"

export interface ThreadStatusSelectProps {
  value: ThreadStatusFilterValue
  onChange: (value: ThreadStatusFilterValue) => void
}

const ThreadStatusSelect = ({ value, onChange }: ThreadStatusSelectProps) => {
  const { t } = useTranslation()
  const triggerId = "thread-status-select"

  return (
    <div className="grid gap-1.5">
      <label
        htmlFor={triggerId}
        className="text-xs font-medium text-muted-foreground"
      >
        {t("historyList.thread.statusFilter.label")}
      </label>
      <Select
        value={value}
        onValueChange={(nextValue) =>
          onChange(nextValue as ThreadStatusFilterValue)
        }
      >
        <SelectTrigger id={triggerId} className="h-9 w-full min-w-0 text-sm">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all" className="pl-6">
            {t("historyList.thread.statusFilter.all")}
          </SelectItem>
          <SelectItem value="pending" className="pl-6">
            {t("historyList.thread.statusFilter.pending")}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}

export default memo(ThreadStatusSelect)
